import Button from "../Dealers/Button";
import { ProgressBar } from "./ProgressBar";
import styles from "./updateModal.module.css";

export const formatDateTime = (input) => {
  if (!input || input === "") return "";

  let date;
  let includeTime = true;

  if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
    const [day, month, year] = input.split("-").map(Number);
    date = new Date(year, month - 1, day);
    includeTime = false;
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  if (!includeTime) {
    return `${day} ${month} ${year}`;
  }

  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${time}, ${day} ${month} ${year}`;
};

const UpdateProductionDrawer = ({
  open,
  currentItem,
  mode,
  productionQty,
  setProductionQty,
  machine,
  setMachine,
  status,
  setStatus,
  addQty,
  completeProduction,
  handleSaveProduction,
  onClose,
}) => {
  const requiredQty = currentItem.requiredQty || currentItem.totalQty || 0;

  const producedQty = currentItem.producedQty || 0;
  const entryQty = Number(productionQty) || 0;

  const totalProduced = producedQty + entryQty;
  const remainingQty = Math.max(requiredQty - totalProduced, 0);
  const extraQty = Math.max(totalProduced - requiredQty, 0);

  if (!open || !currentItem) return null;

  return (
    <div className={styles.modalOverlay}>
      <div
        className={`${styles.updateDrawer} ${
          mode ? styles.updateDrawerDark : ""
        }`}
      >
        <div className={styles.drawerHeader}>
          <h2>Update Production</h2>
          <button onClick={onClose}>✕</button>
        </div>

        <div className={styles.drawerBody}>
          <div className={styles.drawerBody}>
            <div className={styles.infoGrid}>
              <div className={styles.infoCard}>
                <span>Voucher No</span>
                <strong style={{ fontSize: 16 }}>
                  {currentItem.itemCode || currentItem.voucherNo || "—"}
                </strong>
              </div>
              <div className={styles.infoCard}>
                <span>Required Qty</span>
                <strong>
                  {currentItem.requiredQty || currentItem.totalQty || "—"}
                </strong>
              </div>
              <div className={styles.infoCard}>
                <span>Produced Qty</span>
                <strong style={{ color: "#12B76A" }}>
                  {currentItem.producedQty}
                </strong>
              </div>
              <div className={styles.infoCard}>
                <span>Pending Qty</span>
                <strong
                  style={{
                    color: currentItem.pendingQty > 0 ? "#F04438" : "#12B76A",
                  }}
                >
                  {currentItem.pendingQty}
                </strong>
              </div>
            </div>

            <div>
              <ProgressBar
                produced={currentItem.producedQty}
                required={currentItem.requiredQty || currentItem.totalQty || 1}
                mode={mode}
              />
            </div>

            {extraQty > 0 ? (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#F79009",
                }}
              >
                ⚠️ Extra Production: {extraQty} units.
                <br />
                extra production quantity add to order.
              </div>
            ) : (
              remainingQty !== 0 &&
              extraQty === 0 && (
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#12B76A",
                    marginBottom: 12,
                  }}
                >
                  ✅ Current qty update to the order and finish for production
                </div>
              )
            )}

            {remainingQty === 0 && extraQty === 0 && (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#12B76A",
                }}
              >
                ✅ Required production quantity completed successfully.
              </div>
            )}

            <div>
              {currentItem.qtyHistory.length > 0 && (
                <>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: mode ? "#fff" : "#111",
                      marginBottom: 8,
                    }}
                  >
                    📋 Production History ({currentItem.qtyHistory.length}{" "}
                    update
                    {currentItem.qtyHistory.length > 1 ? "s" : ""})
                  </div>

                  <div
                    style={{
                      maxHeight: 180,
                      overflowY: "auto",
                      paddingRight: 4,
                      backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
                      padding: "3px 10px",
                      borderRadius: 10,
                    }}
                  >
                    {currentItem.qtyHistory.map((h, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          // padding: "8px 0",
                          padding: "5px 0",
                          borderBottom:
                            idx !== currentItem.qtyHistory.length - 1
                              ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
                              : "none",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              color: "#12B76A",
                              fontWeight: 600,
                              fontSize: 14,
                            }}
                          >
                            +{h.qty} units
                          </span>
                        </div>

                        <span
                          style={{
                            color: mode ? "#ffffff" : "#6B7280",
                            fontSize: 11,
                            fontWeight: 500,
                          }}
                        >
                          Admin{" / "} {formatDateTime(h.ts)}
                        </span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className={styles.formGroup}>
              <label>Add Production Qty</label>
              <input
                type="number"
                value={productionQty}
                onChange={(e) => setProductionQty(e.target.value)}
                placeholder="Enter quantity..."
              />
            </div>

            <div className={styles.quickBtns}>
              {/* <button onClick={() => addQty(10)}>+10</button>
              <button onClick={() => addQty(20)}>+20</button>
              <button onClick={() => addQty(50)}>+50</button> */}
              <Button
                buttonClick={completeProduction}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonText={"Complete"}
              />
            </div>

            <div className={styles.formGroup}>
              <label>Machine</label>
              <select
                value={machine}
                onChange={(e) => setMachine(e.target.value)}
              >
                <option>Extruder 1</option>
                <option>Extruder 2</option>
                <option>Extruder 3</option>
                <option>Extruder 4</option>
                <option>Loom A</option>
              </select>
            </div>

            {/* <div className={styles.formGroup}>
              <label>Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>In Production</option>
                <option>Ready For Dispatch</option>
                <option>Completed</option>
                <option>Voucher</option>
              </select>
            </div> */}
          </div>
        </div>

        <div className={styles.drawerFooter}>
          <Button
            buttonClick={onClose}
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
          />

          <Button
            buttonClick={handleSaveProduction}
            buttonText={"Save Update"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateProductionDrawer;
